import { render, staticRenderFns } from "./GrcDialog_KartyaAktivalas.vue?vue&type=template&id=76d5a16e&"
import script from "./GrcDialog_KartyaAktivalas.vue?vue&type=script&lang=js&"
export * from "./GrcDialog_KartyaAktivalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports